<template>
  <div class="c-card">
    <Card class="card-box">
      <img :src="info.image_url" class="card-img" />
      <div class="card-info">
        <span class="tool-span">{{ info.title }}</span>
        <span class="tool-span sub-title">{{ info.product_selling_points.join(',') }}</span>
      </div>
      <div class="card-button">
        <div class="fake-button">{{ info.button_text }}</div>
      </div>
      <Icon type="md-close-circle" color="#ed4014" size="16" @click="$emit('on-delete')" class="delete-button" />
    </Card>
    <div class="card-hover">
      <Button class="update-button" size="large" @click="$emit('on-change')">替换</Button>
    </div>
  </div>
</template>
<script>
// import { isArray } from '@/common/js/utils'
export default {
  name: 'CardPreview',
  props: {
    value: {
      type: String
    },
    info: {
      type: Object,
      default() {
        return {
          image_url: '',
          title: '',
          product_selling_points: [],
          button_text: ''
        }
      }
    }
  },
  computed: {},
  data() {
    return {}
  },
  methods: {
    beforeUpload() {}
  }
}
</script>
<style lang="scss" scoped>
.c-card {
  position: relative;

  .card-hover {
    top: 0;
    height: 60px;
    width: 400px;
    position: absolute;
    display: flex;
    justify-content: center;
    opacity: 0;
    background: rgba(85, 85, 85, 0.8);
    border-radius: 5px;

    &:hover {
      opacity: 1;
      border: 1px solid #409eff;
    }

    .update-button {
      width: 100px;
      margin: 10px;
      cursor: auto;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .card-box {
    height: 60px;
    width: 400px;
    margin-bottom: 20px;
    position: relative;
    display: block;
    background: #f2f2f2;

    .card-img {
      position: absolute;
      height: 100%;
      top: 0;
      left: 20px;
      padding: 8px;
    }

    .card-info {
      position: absolute;
      width: 35%;
      height: 100%;
      top: 0;
      padding: 8px;
      left: 75px;

      .tool-span {
        width: 153px;
        font-weight: bold;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 20px;
      }

      .sub-title {
        font-size: 8px;
        font-weight: normal;
        bottom: 5px;
        position: absolute;
      }
    }

    .card-button {
      position: absolute;
      right: 0;
      top: 0;
      width: 40%;
      height: 100%;
      padding: 13px;

      .fake-button {
        background: #409eff;
        height: 100%;
        color: #fff;
        text-align: center;
        line-height: 32px;
        border-radius: 5px;
      }
    }
  }

  .delete-button {
    position: absolute;
    z-index: 1;
    top: -5px;
    right: -10px;
    cursor: pointer;
  }
}

::v-deep .ivu-tooltip {
  line-height: 8px;
}
</style>
